export const BRAND_LOGO_DIMENSIONS = {
  width: 202,
  height: 52
}

export const BRAND_LOGO_SQUARE_DIMENSIONS = {
  width: 120,
  height: 120
}
